module.exports = "<app-toolbar *ngIf=\"showTopBar\"></app-toolbar>\r\n\r\n<div class=\"app-body\">\r\n  <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main